import React, { useCallback, useState } from 'react';

import { useClassName } from '@travpro/hooks';
import i18n from 'i18n-react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

import BackImage from 'custom/BackImage';

import './_preLoginView';

import { storageKeys } from 'settings';

// useTranslate doesn't work in this stack and I can't be bothered fixing it
const useTranslate = (block) => {
  const t = (key, options) => i18n.translate([block, key].join('.'), options);
  t.general = (key, options) => i18n.translate(['general', key].join('.'), options);
  t.error = (key, options) => i18n.translate(['error', key].join('.'), options);
  return t;
};

const PreLoginView = () => {
  const c = useClassName('preLoginView');
  const t = useTranslate('preLoginView');

  return (
    <div {...c()}>
      <div {...c('panel')}>
        <div {...c('content')}>
          <h1>{t('overviewHeader')}</h1>

          <p>{t('overviewBody')}</p>
          <p>{t('overviewFooter')}</p>
          <p>{t('overviewFooter2')}</p>
        </div>

        <div {...c('buttons')}>
          <Link to="/register">{t.general('register')}</Link>
          <Link to="/login">{t.general('login')}</Link>
        </div>
      </div>

      <BackImage key="/main" />
      {localStorage.getItem(storageKeys.user?.name || storageKeys.user) !== null && <Redirect to="/main" />}
    </div>
  );
};

export default PreLoginView;
